import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { AssessmentContainer, AssessmentNavigation } from './common';
import { terminationType, taskType } from './common/task-utility';
import { Box } from '@material-ui/core';
import { staticImages } from '../../assets/static-images';
import { assessmentStatus } from '../../Constants';

class AssessmentComplete extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showNext: false,
			hasTests: false,
			isSaving: true
		};

		this.handleNext = this.handleNext.bind(this);
		this.preventBack = this.preventBack.bind(this);
	}

	componentDidMount() {
		const {
			data,
			match,
			versionID,
			userData,
			setTermination,
			setUserData,
			setAssessmentStatus,
			saveScreenDuration,
			save,
			logToSentry
		} = this.props;

		const { username, tests } = userData;
		const testIndex = tests.findIndex(test => test.versionNum === versionID);
		tests[testIndex].isCompleted = 1;

		if (match.path === '/Assessment/Timeout') {
			logToSentry('warning', 'User timed out', null)
			setTermination(terminationType.TIMEDOUT);
		}

		var unseenItems = [];

		const { tasks } = this.props;
		console.log(this.props);
		const taskIndex = tasks.map(task => task.id).indexOf(taskType.ITEMLIST.id);

		tasks[taskIndex].tasks.filter(task => !task.skipped).forEach((task, index) => {
			if (task.response < 0) {
				unseenItems.push((index + 1));
			}
		});

		if (unseenItems.length != 0) {
			var items = tasks[taskIndex].tasks.filter(task => !task.skipped)
			if (unseenItems.length == items.length) {
				logToSentry('error', `User had all items marked as unseen`, null, {
					unseenItems: unseenItems.length
				}, {
					filename: 'localAssessmentData.json',
					data: data
				});
			} else {
				logToSentry('warning', `User had unseen items`, null, {
					unseenItems: unseenItems.length
				});
			}
		}

		setUserData(userData);
		setAssessmentStatus(assessmentStatus.Complete);
		saveScreenDuration();

		// DO NOT REMOVE THIS SAVE. THIS SAVE IS FOR WHEN USERS TIMEOUT
		var curDate = new Date();

		save({
			username,
			testName: tests[testIndex].fullName,
			value: 1
		}, () => {
			var newDate = new Date();
			var diff = (newDate.getTime() - curDate.getTime()) / 1000;
			if (diff < 1)
				setTimeout(() => {this.setState({isSaving: false})}, 1000)
			else
			this.setState({isSaving: false})
		});

		localStorage.clear();

		const visibleTests = Object.values(tests).filter(test => test.sortOrder !== 0 && test.isCompleted === 0);
		const hasTests = visibleTests.length > 0;
		this.setState({hasTests});

		this.timer = setTimeout(() => {
			this.setState({showNext: hasTests});
		}, 300000);

		window.history.pushState(null, null, window.location.href);
		window.addEventListener('popstate', this.preventBack);
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
		window.removeEventListener('popstate', this.preventBack);
	}

	handleNext() {
		this.props.history.push('/Home');
	}

	preventBack() {
		this.props.history.go(1);
	}

	render() {
		return (
			<>
				{
					this.state.isSaving ? (
						<div className="modal-blur">
							<div style={{fontSize:'25px', width:'100%', color:'white', textAlign: 'center', position: 'fixed', top: 'calc(50% + 60px)'}}></div>
							<div style={{width:'100%'}}>
								<div className="lds-dual-ring"/>
							</div>
						</div>
					) : null
				}
				<AssessmentContainer>
					<Box className="box-container">
						{this.state.hasTests ? (
							<img width="275" height="275" src={staticImages.stopHand} alt="Stop" />
						) : (
							<>
								<img width="88" height="88" src={staticImages.checkMark} alt="Completed" />
								<Box className="thank-you-text">Thank You.</Box>
							</>
						)}
					</Box>
					<AssessmentNavigation type="next" onClick={this.handleNext} isVisible={this.state.showNext} />
				</AssessmentContainer>
				</>
		);
	}
}

const mapStateToProps = state => ({
	data: state.data,
	tasks: state.data.tasks,
	versionID: state.data.versionID,
	userData: state.data.userData
});

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentComplete));